'use client';

import React from 'react';

export default function LoadingSpinner() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
            <div className="relative">
                <div className="w-10 h-10 border-2 border-gray-200 rounded-full"></div>
                <div className="absolute inset-0 w-10 h-10 border-2 border-transparent border-t-violet-600 rounded-full animate-spin"></div>
            </div>
        </div>
    );
}
